import {createReducer} from '@reduxjs/toolkit'
import {TicketWithFormattedSalePeriod} from '@wix/wix-events-commons-statics'
import {changeEventAction} from '../actions/event'

const defaultState: TicketWithFormattedSalePeriod[] = []

export const tickets = createReducer(defaultState, builder => {
  builder.addCase(changeEventAction, (_, action) => {
    return action.payload.tickets
  })
})
